<div [style.background-image]="' url(' + background + ')'" class="{{backgroundSizer}}">
  <prescp-header *ngIf="headerShow"></prescp-header>
  <router-outlet></router-outlet>
  <prescp-alert *ngIf="alertShow" [options]="alertOptions"></prescp-alert>
  <prescp-footer *ngIf="footerShow"></prescp-footer>
</div>
